import React from 'react';
import { Switch, Route } from 'react-router-dom';
import RestaurationList from './restauration-list';
import RestaurationForm from './restauration-form';
import { paths } from '../../../routes';

const Restauration = () => (
    <Switch>
        <Route path={paths.newRestauration.path}>
            <RestaurationForm />
        </Route>
        <Route path={paths.restauration.path + '/:reportId'}>
            <RestaurationForm />
        </Route>
        <Route path={paths.restauration.path}>
            <RestaurationList />
        </Route>
    </Switch>
);

export default Restauration;
